import React, { useContext } from 'react';
import { View, Text, ScrollView } from 'react-native';
import { ColumnContainer, LeftContainer, RightContainer } from '../elements';
import UpcomingSales from './Sales/Upcoming';
import Stats from './Stats';
import Assignments from './Notifications/Assignments';
import UserContext from '../contexts/UserContext';

const Home = () => {
  const { isMobile, screenWidth } = useContext(UserContext);
  return (
    <ColumnContainer isMobile={isMobile} style={{flexGrow: 1, flex: 1}}>
      <ScrollView
        contentContainerStyle={{ flexGrow: 1, flexDirection: isMobile ? 'column' : 'row' }}
        style={{ flex: 1, flexGrow: 1, minHeight: '100vh'}}
      >
        <LeftContainer isMobile={isMobile}>
          <UpcomingSales />
        </LeftContainer>
        <RightContainer isMobile={isMobile} screenWidth={screenWidth}>
          <Stats />
          <Assignments />
        </RightContainer>
      </ScrollView>
    </ColumnContainer>
  )
}

export default Home;
